export const DOCUMENTO_RECURRENTE_ESTADO = {
  EN_CURSO: 1,
  FINALIZADO: 2,
} as const

export type DocumentoRecurrenteEstadoType =
  (typeof DOCUMENTO_RECURRENTE_ESTADO)[keyof typeof DOCUMENTO_RECURRENTE_ESTADO]
